<template>
  <div class="archive20250821" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} 大学見本市2025 出展報告</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">2025年8月21日から22日に開催された大学見本市2025に出展しました．</div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">出展タイトル：「メンタル不調を早期発見するAIストレスチェッカー」</div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20250821_1.png`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20250821_2.png`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>
